<div class="page">
  <app-page-header page-title="{{ pageTitleKey }}"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <app-card-spinner [visible]="areasAreLoading || previewIsLoading" type="zero"></app-card-spinner>
      <mat-card-title>{{ 'settings.documentTemplate.detail' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'settings.documentTemplate.editing' | translate }}</mat-card-subtitle>

      <mat-card-content>

        <!-- Toolbar -->
        <div class="dt-toolbar">
          <mat-form-field class="dt-search">
            <mat-label>{{ 'settings.documentTemplate.searchAreas' | translate }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="areaSearch"
              (ngModelChange)="applyAreaSearch()"
              [placeholder]="'settings.documentTemplate.searchAreas' | translate">
            <button
              mat-icon-button
              matSuffix
              *ngIf="areaSearch"
              (click)="areaSearch = ''; applyAreaSearch()"
              [attr.aria-label]="'common.cta.reset' | translate">
              <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
            </button>
            <mat-icon matSuffix fontSet="fal" fontIcon="fa-search" *ngIf="!areaSearch"></mat-icon>
          </mat-form-field>

          <mat-slide-toggle
            class="dt-toolbar-toggle"
            [(ngModel)]="includeDeleted"
            (change)="onIncludeDeletedChange()">
            {{ 'settings.documentTemplate.showHidden' | translate }}
          </mat-slide-toggle>

          <span class="dt-toolbar-spacer"></span>

          <button mat-raised-button color="primary" (click)="onAddAreaClicked()">
            <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
            {{ 'settings.documentTemplate.actions.addArea' | translate }}
          </button>
        </div> <!-- /.dt-toolbar -->

        <div class="dt-hint" *ngIf="areaDragIsDisabled && areaSearch">
          <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
          <span>{{ 'settings.documentTemplate.hints.dragDisabledBySearch' | translate }}</span>
        </div>

        <div class="row">

          <!-- BEGIN - Level 1: areas -->
          <div class="col-12 col-lg-4 dt-column">
            <div class="dt-column-title">
              {{ 'settings.documentTemplate.areasTitle' | translate }}
              <span class="dt-count" *ngIf="areas.length">{{ areas.length }}</span>
            </div>

            <!-- Empty state -->
            <div class="dt-empty" *ngIf="!areasAreLoading && areas.length === 0">
              <mat-icon fontSet="fal" fontIcon="fa-folder-open"></mat-icon>
              <p class="dt-empty-title">{{ 'settings.documentTemplate.empty.areasTitle' | translate }}</p>
              <p class="dt-empty-text">{{ 'settings.documentTemplate.empty.areasText' | translate }}</p>
              <button mat-raised-button color="primary" (click)="onAddAreaClicked()">
                <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                {{ 'settings.documentTemplate.actions.addArea' | translate }}
              </button>
            </div>

            <div
              class="dt-list"
              cdkDropList
              [cdkDropListData]="visibleAreas"
              (cdkDropListDropped)="onAreaDropped($event)"
              *ngIf="areas.length">
              <div
                class="dt-row"
                *ngFor="let area of visibleAreas"
                cdkDrag
                [cdkDragDisabled]="areaDragIsDisabled"
                [class.dt-row-selected]="selectedArea && selectedArea._id === area._id"
                [class.dt-row-hidden]="area.deleted">

                <mat-icon
                  class="dt-drag-handle"
                  cdkDragHandle
                  fontSet="fal"
                  fontIcon="fa-grip-vertical"
                  [class.dt-drag-handle-off]="areaDragIsDisabled"
                  [matTooltip]="'settings.documentTemplate.hints.drag' | translate"></mat-icon>

                <button type="button" class="dt-row-main" (click)="onAreaClicked(area)">
                  <span class="dt-code">{{ area.code }}</span>
                  <span class="dt-label">{{ nodeLabel(area) }}</span>
                  <span class="dt-badges">
                    <span class="dt-badge dt-badge-deleted" *ngIf="area.deleted">
                      {{ 'settings.documentTemplate.badges.hidden' | translate }}
                    </span>
                    <span class="dt-badge dt-badge-invisible" *ngIf="!area.deleted && !area.visible">
                      {{ 'settings.documentTemplate.badges.notVisible' | translate }}
                    </span>
                    <span class="dt-badge dt-badge-neutral" *ngIf="area.type === 'link'">
                      {{ 'settings.documentTemplate.types.link' | translate }}
                    </span>
                  </span>
                </button>

                <div class="dt-row-actions">
                  <button
                    mat-icon-button
                    color="warn"
                    *ngIf="!area.deleted"
                    [disabled]="previewIsLoading"
                    (click)="onDeleteArea(area)"
                    [matTooltip]="'settings.documentTemplate.actions.delete' | translate">
                    <mat-icon fontSet="fal" fontIcon="fa-trash-alt"></mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    color="primary"
                    *ngIf="area.deleted"
                    (click)="onRestoreArea(area)"
                    [matTooltip]="'settings.documentTemplate.actions.restore' | translate">
                    <mat-icon fontSet="fal" fontIcon="fa-trash-restore"></mat-icon>
                  </button>
                </div>
              </div> <!-- /.dt-row -->

              <div class="dt-empty-search" *ngIf="visibleAreas.length === 0">
                {{ 'common.words.no_search_results' | translate }}
              </div>
            </div> <!-- /.dt-list -->

            <div class="dt-legend" *ngIf="includeDeleted">
              <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
              <span>{{ 'settings.documentTemplate.hints.restoreNotCascading' | translate }}</span>
            </div>
          </div> <!-- /.col -->
          <!-- END - Level 1: areas -->

          <!-- BEGIN - Right column -->
          <div class="col-12 col-lg-8 dt-column">

            <!-- No selection -->
            <div class="dt-empty dt-empty-panel" *ngIf="rightPanel === 'empty'">
              <mat-icon fontSet="fal" fontIcon="fa-hand-pointer"></mat-icon>
              <p class="dt-empty-text">{{ 'settings.documentTemplate.empty.selectArea' | translate }}</p>
            </div>

            <!-- BEGIN - Area editor -->
            <ng-container *ngIf="rightPanel === 'area' && selectedArea">
              <div class="dt-panel-title">
                <span>{{ nodeLabel(selectedArea) }}</span>
                <span class="dt-badge dt-badge-deleted" *ngIf="selectedArea.deleted">
                  {{ 'settings.documentTemplate.badges.hidden' | translate }}
                </span>
              </div>

              <!-- Identifiers -->
              <div class="dt-identifiers">
                <div class="dt-identifier">
                  <span class="dt-identifier-label">{{ 'settings.documentTemplate.fields.code' | translate }}</span>
                  <code>{{ selectedArea.code }}</code>
                </div>
                <button
                  mat-stroked-button
                  color="warn"
                  class="dt-identifier-btn"
                  *ngIf="!areaIdentifiersUnlocked"
                  (click)="onUnlockAreaIdentifiers()">
                  <mat-icon fontSet="fal" fontIcon="fa-lock"></mat-icon>
                  {{ 'settings.documentTemplate.actions.unlockIdentifier' | translate }}
                </button>
                <span class="dt-identifier-unlocked" *ngIf="areaIdentifiersUnlocked">
                  <mat-icon fontSet="fal" fontIcon="fa-unlock"></mat-icon>
                  {{ 'settings.documentTemplate.identifierUnlocked' | translate }}
                </span>
              </div>
              <div class="dt-hint dt-hint-warn">
                <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                <span>{{ 'settings.documentTemplate.hints.identifierWarning' | translate }}</span>
              </div>

              <div class="dt-hint dt-hint-warn" *ngIf="areaCheckIsDegraded">
                <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                <span>{{ 'settings.documentTemplate.hints.duplicateCheckUnavailable' | translate }}</span>
              </div>

              <div class="dt-form form-wrapper mt-2">
                <form [formGroup]="areaForm" (ngSubmit)="onAreaSubmit()">
                  <formly-form
                    [form]="areaForm"
                    [fields]="areaFields"
                    [model]="areaModel"
                    [options]="areaOptions">
                  </formly-form>
                </form>
                <mat-spinner-button
                  (btnClick)="onAreaSubmit()"
                  role="submit"
                  [options]="areaBtnOptions"
                  class="btn-elevate">
                </mat-spinner-button>
              </div>

              <hr />

              <!-- BEGIN - Level 2: sections -->
              <div class="dt-column-title dt-column-title-inline">
                <span>
                  {{ 'settings.documentTemplate.contentsTitle' | translate }}
                  <span class="dt-count" *ngIf="contents.length">{{ contents.length }}</span>
                </span>
                <button mat-raised-button color="primary" (click)="onAddContentClicked()">
                  <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                  {{ 'settings.documentTemplate.actions.addContent' | translate }}
                </button>
              </div>

              <div class="dt-inline-spinner" *ngIf="contentsAreLoading">
                <mat-spinner strokeWidth="3" [diameter]="28" mode="indeterminate"></mat-spinner>
              </div>

              <div class="dt-empty dt-empty-inline" *ngIf="!contentsAreLoading && contents.length === 0">
                <p class="dt-empty-text">
                  {{ 'settings.documentTemplate.empty.contentsText' | translate:{ name: nodeLabel(selectedArea) } }}
                </p>
              </div>

              <div
                class="dt-list"
                cdkDropList
                [cdkDropListData]="contents"
                (cdkDropListDropped)="onContentDropped($event)"
                *ngIf="!contentsAreLoading && contents.length">
                <div
                  class="dt-row"
                  *ngFor="let content of contents"
                  cdkDrag
                  [cdkDragDisabled]="reorderIsSaving"
                  [class.dt-row-hidden]="content.deleted">

                  <mat-icon
                    class="dt-drag-handle"
                    cdkDragHandle
                    fontSet="fal"
                    fontIcon="fa-grip-vertical"
                    [matTooltip]="'settings.documentTemplate.hints.drag' | translate"></mat-icon>

                  <button type="button" class="dt-row-main" (click)="onContentClicked(content)">
                    <span class="dt-code">{{ content.code }}</span>
                    <span class="dt-label">{{ nodeLabel(content) }}</span>
                    <span class="dt-badges">
                      <span class="dt-badge dt-badge-deleted" *ngIf="content.deleted">
                        {{ 'settings.documentTemplate.badges.hidden' | translate }}
                      </span>
                      <span class="dt-badge dt-badge-invisible" *ngIf="!content.deleted && !content.visible">
                        {{ 'settings.documentTemplate.badges.notVisible' | translate }}
                      </span>
                      <span class="dt-badge dt-badge-structure" *ngIf="content.elementType === 'array'">
                        {{ 'settings.documentTemplate.badges.structure' | translate }}
                      </span>
                    </span>
                  </button>

                  <div class="dt-row-actions">
                    <button
                      mat-icon-button
                      *ngIf="!content.deleted"
                      [disabled]="moveIsLoading"
                      (click)="onMoveContent(content)"
                      [matTooltip]="'settings.documentTemplate.actions.move' | translate">
                      <mat-icon fontSet="fal" fontIcon="fa-exchange"></mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      *ngIf="!content.deleted"
                      [disabled]="previewIsLoading"
                      (click)="onDeleteContent(content)"
                      [matTooltip]="'settings.documentTemplate.actions.delete' | translate">
                      <mat-icon fontSet="fal" fontIcon="fa-trash-alt"></mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="primary"
                      *ngIf="content.deleted"
                      [disabled]="restoreContentIsBlocked()"
                      (click)="onRestoreContent(content)"
                      [matTooltip]="restoreContentIsBlocked()
                        ? ('settings.documentTemplate.hints.restoreBlocked' | translate)
                        : ('settings.documentTemplate.actions.restore' | translate)">
                      <mat-icon fontSet="fal" fontIcon="fa-trash-restore"></mat-icon>
                    </button>
                  </div>
                </div> <!-- /.dt-row -->
              </div> <!-- /.dt-list -->

              <!-- New section form -->
              <div class="dt-subpanel" *ngIf="newContentIsVisible">
                <div class="dt-subpanel-title">
                  <span>{{ 'settings.documentTemplate.newContentTitle' | translate }}</span>
                  <button
                    mat-icon-button
                    (click)="newContentIsVisible = false"
                    [attr.aria-label]="'common.cta.close' | translate">
                    <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
                  </button>
                </div>
                <div class="dt-hint">
                  <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
                  <span>{{ 'settings.documentTemplate.hints.englishLabelIsTheIdentifier' | translate }}</span>
                </div>
                <div class="dt-hint dt-hint-warn" *ngIf="contentCheckIsDegraded">
                  <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                  <span>{{ 'settings.documentTemplate.hints.duplicateCheckUnavailable' | translate }}</span>
                </div>
                <div class="dt-form form-wrapper">
                  <form [formGroup]="newContentForm" (ngSubmit)="onNewContentSubmit()">
                    <formly-form
                      [form]="newContentForm"
                      [fields]="newContentFields"
                      [model]="newContentModel"
                      [options]="newContentOptions">
                    </formly-form>
                  </form>
                  <div class="dt-form-actions">
                    <mat-spinner-button
                      (btnClick)="onNewContentSubmit()"
                      role="submit"
                      [options]="newContentBtnOptions"
                      class="btn-elevate">
                    </mat-spinner-button>
                  </div>
                </div>
              </div>
              <!-- END - Level 2: sections -->
            </ng-container>
            <!-- END - Area editor -->

            <!-- BEGIN - New area editor -->
            <ng-container *ngIf="rightPanel === 'newArea'">
              <div class="dt-panel-title">
                <span>{{ 'settings.documentTemplate.newAreaTitle' | translate }}</span>
                <button
                  mat-icon-button
                  (click)="rightPanel = 'empty'"
                  [attr.aria-label]="'common.cta.close' | translate">
                  <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
                </button>
              </div>
              <div class="dt-hint dt-hint-warn">
                <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                <span>{{ 'settings.documentTemplate.hints.identifierWarning' | translate }}</span>
              </div>
              <div class="dt-hint">
                <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
                <span>{{ 'settings.documentTemplate.hints.englishLabelIsTheIdentifier' | translate }}</span>
              </div>
              <div class="dt-hint dt-hint-warn" *ngIf="areaCheckIsDegraded">
                <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                <span>{{ 'settings.documentTemplate.hints.duplicateCheckUnavailable' | translate }}</span>
              </div>

              <div class="dt-form form-wrapper mt-2">
                <form [formGroup]="newAreaForm" (ngSubmit)="onNewAreaSubmit()">
                  <formly-form
                    [form]="newAreaForm"
                    [fields]="newAreaFields"
                    [model]="newAreaModel"
                    [options]="newAreaOptions">
                  </formly-form>
                </form>
                <div class="dt-form-actions">
                  <mat-spinner-button
                    (btnClick)="onNewAreaSubmit()"
                    role="submit"
                    [options]="newAreaBtnOptions"
                    class="btn-elevate">
                  </mat-spinner-button>
                </div>
              </div>
            </ng-container>
            <!-- END - New area editor -->

          </div> <!-- /.col -->
          <!-- END - Right column -->

        </div> <!-- /.row -->
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->
